// extracted by mini-css-extract-plugin
module.exports = {"container":"quick-view-error_container__FuO3W","info":"quick-view-error_info__FSVr1"};